"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common = require("./common");
var home = require("./home");
document.addEventListener('DOMContentLoaded', function () {
    common.exec();
    home.exec();
});
